import { Component, OnInit } from '@angular/core';
import { AppSingle } from '../../app-single';
import { TabsModel } from '../infinite-scroll-list/tabs.model';
import { InfiniteListModel, InfiniteDetaiListModel } from '../infinite-scroll-list/infiniteList.model';
import { ActivatedRoute } from '@angular/router';
import { ExtractService } from '../../services/extract.service';
import { NotificationService } from '../../notification/swal/notification.service';
import { ExtractModel, Extrato } from '../../models/extract.model';

@Component({
  selector: 'app-extract',
  templateUrl: './extract.component.html',
  styleUrls: ['./extract.component.less']
})
export class ExtractComponent extends AppSingle implements OnInit {
  viaAnteriorTag: string;
  currentPage = 0;
  bottom = false;
  filter = 7;
  tabs: TabsModel[] = [
    { title: '7 Dias', value: 7},
    { title: '30 Dias', value: 30},
    { title: '60 Dias', value: 60},
  ];
  extracts: InfiniteListModel[] = new Array<InfiniteListModel>();

  constructor(route: ActivatedRoute, private extractService: ExtractService, private notificationService: NotificationService) {
    super(route);
  }

  goToLastExtract() {
    this.id = this.viaAnteriorTag;
    this.onFilter(7);
  }

  formatExtractChildren(_extract: Extrato[]) {
    _extract.forEach((extract) => {
      this.extracts.push(
        {
          id: extract.PedidoId,
          transactionType: extract.TipoTransacao,
          name: extract.Local,
          total: extract.Valor,
          date: this.convertToUTCDate(extract.DataRealizacao),
          detail: null,
          open: false,
          dependentId: null
        }
      );
    });
  }

  private convertToUTCDate(datetoConvert: Date): Date {
    const date = new Date(datetoConvert);
    const userTimezoneOffset = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - userTimezoneOffset);
  }

  getExtract() {
    this.extractService.getAllByFilter(this.currentPage, this.filter, this.id, this.tipo)
    .then((_extract) => {
      if (this.tipo === 'rotativo') {
        if (_extract.length === 0) {
          this.bottom = true;
        } else {
          this.bottom = false;
          this.formatExtractChildren(_extract);
        }
      } else {
        this.viaAnteriorTag = _extract.ViaAnteriorTag;
        if (_extract.Extrato.length === 0) {
          this.bottom = true;
        } else {
          this.bottom = false;
          this.formatExtractChildren(_extract.Extrato);
        }
      }
    })
    .catch((err) => {
      this.notificationService.showErrorNotification(err.message);
    })
    .then(() => {
      this.notificationService.closeLoading();
    });
  }

  getDetails(id: string) {
    this.extractService.getDetails(this.id, id, this.tipo)
      .then((_details: any) => {
        const extract = this.extracts.find(_extract => _extract.id === id);
        extract.detail =  new Array<InfiniteDetaiListModel>();
        _details.forEach(detail => {
          extract.detail.push({
            name: detail.NomeProduto,
            price: detail.ValorProduto,
            quantity: detail.QuantidadeProduto,
            total: detail.ValorTotal
          });
        });
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      })
      .then(() => {
        this.notificationService.closeLoading();
      });
  }

  ngOnInit() {
    this.onFilter(7);
  }

  onScroll(page) {
    this.currentPage = page;
    this.getExtract();
  }

  onFilter(filter) {
    this.notificationService.openLoading();
    this.currentPage = 0;
    this.bottom = false;
    this.filter = filter;
    this.extracts = new Array<InfiniteListModel>();
    this.getExtract();
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/extract/extract.component.ts